"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRemovedItemFromCart = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackRemovedItemFromCart(cartItem) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.CartEventType.DeleteItem,
        eventLabel: cartItem.product.trackingName,
        eventData: {
            eventName: enums_1.GA4EventName.DeleteCartProduct,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            product_count_changed: -cartItem.quantity,
            product_title: cartItem.product.title,
        },
    });
}
exports.trackRemovedItemFromCart = trackRemovedItemFromCart;
//# sourceMappingURL=trackCartRemoveItem.js.map